import {OnInit, Input, OnDestroy, Directive, ElementRef, Renderer2} from '@angular/core';
import {CellClickEvent, GridComponent, GridDataResult, RowArgs} from '@progress/kendo-angular-grid';
import {Subject, Subscription} from 'rxjs';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[inCellTab]'
})
export class InCellTabDirective implements OnInit, OnDestroy {
    @Input()
    public wrap = true;
    @Input('inCellTab')
    public currentRowSelected: any[] = [];
    public gridCellClick: Subscription;
    private clickListen: () => void;
    @Input()
    private inputsClicked: Subject<any>;
    private unsubKeydown: () => void;

    constructor(
        private grid: GridComponent,
        private el: ElementRef,
        private renderer: Renderer2) {
    }

    public isRowSelected = (e: RowArgs) => this.currentRowSelected.indexOf(e.index) >= 0;

    public ngOnInit(): void {
        this.grid.rowSelected = this.isRowSelected;
        this.gridCellClick = this.grid.cellClick.subscribe((e) => this.cellClicked(e));
        this.clickListen = this.renderer.listen(this.el.nativeElement, 'click', (e) => this.click(e));
        this.unsubKeydown = this.renderer.listen(
            this.el.nativeElement, 'keydown', (e) => this.onKeydown(e)
        );
        this.inputsClicked.subscribe((e) => {
            this.inputChecked(e);
        });
    }

    public ngOnDestroy(): void {
        this.unsubKeydown();
        this.gridCellClick.unsubscribe();
        this.clickListen();
        this.inputsClicked.unsubscribe();
    }

    public onKeydown(e: KeyboardEvent): void {
        try {
            if (e.key !== 'Tab' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') {
                return;
            }
            e.preventDefault();
            let nextRow = 0;
            const currentrow = this.currentRowSelected;
            if (e.key === 'Tab') {
                if (this.checkLast(currentrow)) {
                    return;
                }
                nextRow = +currentrow + 1;
            } else if (e.key === 'ArrowDown') {
                if (this.checkLast(currentrow)) {
                    return;
                }
                nextRow = +currentrow + 1;
            } else if (e.key === 'ArrowUp') {
                if (this.checkFirst(currentrow)) {
                    return;
                }

                nextRow = +currentrow - 1;
                this.grid.scrollTo({row: nextRow});
            } else if (e.key === 'Enter') {
                if (this.checkLast(currentrow)) {
                    return;
                }
                nextRow = +currentrow + 1;
            }
            this.selectRow(nextRow);
        } catch (error) {
        }
    }

    public checkLast(number) {
        const gridData = this.grid.data as GridDataResult;
        return +number >= (gridData.total - 1);
    }

    public checkFirst(number) {
        return +number === 0;
    }

    public selectRow(selectedRow) {
        if (selectedRow == null) {
            return;
        }
        this.currentRowSelected = [selectedRow];
        const grid = this.grid.wrapper.nativeElement as HTMLElement;
        const results = grid.querySelector(`tr[data-kendo-grid-item-index="${selectedRow}"]`);
        if (results == null) {
            return;
        }

        const number = this.determineScroll(selectedRow);
        if (number !== 0) {
            this.grid.scrollTo({row: number});
        }
        const tr = results.querySelector('input');
        if (tr != null) {
            tr.focus();
            tr.select();
        }
    }

    private cellClicked(e: CellClickEvent) {
        this.selectRow(e.rowIndex);
    }

    private determineScroll(row) {
        const page = this.grid.pageSize;
        const skip = this.grid.skip;
        if (page !== null && skip !== null) {
            const pageSkip = skip + page;
            if ((pageSkip - row) < 5) {
                return row;
            }
        }
        return 0;
    }

    private inputChecked(e: any) {
        const id = e.target.id;
        this.selectRow(+id);
    }

    private click(e: any) {
        console.log(e);
        return undefined;
    }
}
